/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_No_DateInputs */

const en_ticket_no_date = /** @type {(inputs: Ticket_No_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No date scheduled`)
};

const ja_ticket_no_date = /** @type {(inputs: Ticket_No_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定日未定`)
};

const fr_ticket_no_date = /** @type {(inputs: Ticket_No_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune date planifiée`)
};

const de_ticket_no_date = /** @type {(inputs: Ticket_No_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Termin geplant`)
};

/**
* | output |
* | --- |
* | "No date scheduled" |
*
* @param {Ticket_No_DateInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_no_date = /** @type {((inputs?: Ticket_No_DateInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_No_DateInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_no_date(inputs)
	if (locale === "ja") return ja_ticket_no_date(inputs)
	if (locale === "fr") return fr_ticket_no_date(inputs)
	return de_ticket_no_date(inputs)
});